import { appFormUtil } from 'modules';
import React from 'react';
import * as types from './types';
const initialState = {
  filter: false,
  freeTextSearch: '',
  trends: []
};

export function useQuery() {
  const form = appFormUtil.useFormState<types.IFormState>({
    initialState,
    key2FieldConfig: {
      trends: {
        label: 'Filter'
      }
    }
  });

  return React.useMemo(
    () => {

      return {
        form
      };
    },
    [form]
  );
}



